<template>
  <div class="pona-website">
    <!-- Navigation Bar -->
    <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top">
      <div class="container">
        <a class="navbar-brand d-flex align-items-center" href="#home">
          <img src="https://pona.paysol.africa/logos/pona.png" alt="PONA HEALTH-X Logo" height="50" class="me-3">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">

          <ul class="navbar-nav ms-auto align-items-center">
            <li class="nav-item">
              <a class="nav-link" href="javascript: void(0);" @click="goToPage('/')">Home</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" href="javascript: void(0);" @click="goToPage('about')">About</a>
            </li>
            <li class="nav-item d-none">
              <a class="nav-link" href="#how-it-works">How It Works</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#benefits">Benefits</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#services">Health Services</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#enrollment">Enrollment</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#facilities">Health Facilities</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#faqs">FAQs</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#contact">Contact</a>
            </li>

            <li class="nav-item dropdown ms-3">
              <button class="btn btn-primary dropdown-toggle" type="button"
                      id="loginDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bx bx-user me-2"></i>Login
              </button>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="loginDropdown">
                <li>
                  <a class="dropdown-item" @click="goToMemberLogin">
                    <i class="bx bx-user-circle me-2"></i>Member Portal
                  </a>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li>
                  <a class="dropdown-item" @click="goToStaffLogin">
                    <i class="bx bx-briefcase me-2"></i>Staff Login
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Hero Section -->
    <section id="home" class="hero-section">
      <div class="hero-overlay"></div>
      <div class="container">
        <div class="row align-items-center min-vh-100 py-5">
          <div class="col-lg-6 text-white hero-content">
            <div class="hero-badge mb-4 animate-on-scroll">
              <i class="bx bx-shield-check me-2"></i>
              Pona Health-X Insurance Cover
            </div>
            <h1 class="display-3 fw-bold mb-4 animate-on-scroll text-white">
              PONA HEALTH-X
            </h1>
            <h2 class="h1 mb-4 animate-on-scroll text-white">
              Community-Based Health Insurance
            </h2>
            <p class="lead mb-5 animate-on-scroll">
              Ensuring universal health coverage for all through affordable,
              community-driven health insurance. Join millions in securing your family's
              health and financial wellbeing.
            </p>
            <div class="d-flex flex-wrap gap-3 animate-on-scroll">
              <button class="btn btn-light btn-lg px-5" @click="scrollToSection('enrollment')">
                <i class="bx bx-user-plus me-2"></i>
                Enroll Now
              </button>
              <button class="btn btn-outline-light btn-lg px-5" @click="scrollToSection('pona-overview')">
                <i class="bx bx-info-circle me-2"></i>
                Learn More
              </button>
            </div>

            <!-- Quick Stats -->
            <div class="row mt-5 pt-5">
              <div class="col-4 animate-on-scroll">
                <div class="stat-card">
                  <div class="stat-number">{{ formatNumber(stats.members) }}M+</div>
                  <div class="stat-label">Enrolled Members</div>
                </div>
              </div>
              <div class="col-4 animate-on-scroll">
                <div class="stat-card">
                  <div class="stat-number">{{ formatNumber(stats.facilities) }}+</div>
                  <div class="stat-label">Health Facilities</div>
                </div>
              </div>
              <div class="col-4 animate-on-scroll">
                <div class="stat-card">
                  <div class="stat-number">{{ stats.coverage }}%</div>
                  <div class="stat-label">Coverage Rate</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 animate-on-scroll">
            <div class="hero-image-container">
              <img src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800"
                   alt="Healthcare"
                   class="img-fluid rounded-4 shadow-lg">
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- About PONA HEALTH-X Section -->
    <section id="ministry" class="py-5 bg-light">
      <div class="container py-5">
        <div class="row">
          <div class="col-lg-12 text-center mb-5 animate-on-scroll">
            <div class="section-badge mb-3 d-inline-block">
              <i class="bx bx-buildings me-2"></i>About PONA HEALTH-X
            </div>
            <h2 class="display-5 fw-bold mb-3">PONA HEALTH-X Insurance</h2>
            <p class="lead text-muted">Leading the transformation of healthcare coverage</p>
          </div>
        </div>

        <div class="row align-items-center mb-5">
          <div class="col-lg-6 mb-4 mb-lg-0 animate-on-scroll">
            <img src="https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=600"
                 alt="PONA HEALTH-X"
                 class="img-fluid rounded-4 shadow">
          </div>
          <div class="col-lg-6 animate-on-scroll">
            <h3 class="fw-bold mb-4">Our Mandate</h3>
            <p class="mb-3">
              PONA HEALTH-X is committed to formulating, implementing, and monitoring health insurance policies,
              strategies, and programs. We are dedicated to ensuring equitable access to quality healthcare
              services for all citizens.
            </p>
            <p class="mb-4">
              Through the PONA HEALTH-X community-based health insurance program, we are
              working towards achieving Universal Health Coverage (UHC) and protecting families from
              financial hardship due to healthcare costs.
            </p>

            <div class="row g-3">
              <div class="col-md-6">
                <div class="ministry-highlight">
                  <i class="bx bx-hospital text-primary fs-3 mb-2"></i>
                  <h6 class="fw-bold">Healthcare Access</h6>
                  <p class="small text-muted mb-0">Expanding health facility networks nationwide</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="ministry-highlight">
                  <i class="bx bx-group text-success fs-3 mb-2"></i>
                  <h6 class="fw-bold">Community Health</h6>
                  <p class="small text-muted mb-0">Empowering health extension workers</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="ministry-highlight">
                  <i class="bx bx-shield-check text-info fs-3 mb-2"></i>
                  <h6 class="fw-bold">Financial Protection</h6>
                  <p class="small text-muted mb-0">Protecting families from health costs</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="ministry-highlight">
                  <i class="bx bx-world text-warning fs-3 mb-2"></i>
                  <h6 class="fw-bold">Global Partnerships</h6>
                  <p class="small text-muted mb-0">Collaborating with WHO, UNICEF, and partners</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Vision & Mission Section -->
    <section id="vision" class="py-5">
      <div class="container py-5">
        <div class="row g-4">
          <div class="col-lg-6 animate-on-scroll">
            <div class="vision-card h-100">
              <div class="vision-icon">
                <i class="bx bx-target-lock"></i>
              </div>
              <h3 class="fw-bold mb-3">Our Vision</h3>
              <p class="lead mb-4">
                "To see healthy, productive, and prosperous communities"
              </p>
              <p class="text-muted">
                We envision a world where every citizen, regardless of their economic status or
                geographic location, has access to quality healthcare services. Through the PONA HEALTH-X program,
                we are building a healthcare system that protects families from financial catastrophe
                while ensuring timely access to needed medical care.
              </p>
            </div>
          </div>

          <div class="col-lg-6 animate-on-scroll">
            <div class="mission-card h-100">
              <div class="mission-icon">
                <i class="bx bx-bullseye"></i>
              </div>
              <h3 class="fw-bold mb-3">Our Mission</h3>
              <p class="lead mb-4">
                "Ensuring equitable and affordable quality health services for all"
              </p>
              <ul class="mission-list">
                <li><i class="bx bx-check-circle text-success me-2"></i>Provide universal health coverage through sustainable financing</li>
                <li><i class="bx bx-check-circle text-success me-2"></i>Strengthen community-based healthcare delivery systems</li>
                <li><i class="bx bx-check-circle text-success me-2"></i>Reduce out-of-pocket health expenditures</li>
                <li><i class="bx bx-check-circle text-success me-2"></i>Improve health outcomes across all regions</li>
                <li><i class="bx bx-check-circle text-success me-2"></i>Build resilient health systems for future generations</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- PONA HEALTH-X Overview Section -->
    <section id="pona-overview" class="py-5 bg-light">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-badge mb-3 d-inline-block">
            <i class="bx bx-info-circle me-2"></i>Understanding PONA HEALTH-X
          </div>
          <h2 class="display-5 fw-bold mb-3">What is PONA HEALTH-X?</h2>
          <p class="lead text-muted">Community-Based Health Insurance Program</p>
        </div>

        <div class="row mb-5">
          <div class="col-lg-8 mx-auto animate-on-scroll">
            <div class="pona-intro-card">
              <p class="lead mb-4">
                The PONA HEALTH-X scheme is a flagship health financing program designed to provide
                financial risk protection and improve access to healthcare services for communities,
                particularly rural populations and the informal sector.
              </p>
              <p class="mb-4">
                PONA HEALTH-X operates on the principles of <strong>solidarity</strong>, <strong>equity</strong>,
                and <strong>community participation</strong>. Members pay affordable annual premiums
                based on their ability to pay, pooling resources to cover healthcare costs for the
                entire community.
              </p>
              <div class="alert alert-info">
                <i class="bx bx-info-circle me-2"></i>
                <strong>Did you know?</strong> PONA HEALTH-X covers over {{ formatNumber(stats.members) }} million
                members across {{ stats.regions }} regions, making it one of the largest
                community health insurance programs.
              </div>
            </div>
          </div>
        </div>

        <div class="row g-4">
          <div class="col-md-4 animate-on-scroll">
            <div class="principle-card">
              <div class="principle-icon">
                <i class="bx bx-group"></i>
              </div>
              <h5 class="fw-bold mb-3">Community Solidarity</h5>
              <p class="text-muted">
                Healthy members support those who fall ill. Rich support the poor.
                Young support the elderly. Everyone contributes, everyone benefits.
              </p>
            </div>
          </div>

          <div class="col-md-4 animate-on-scroll">
            <div class="principle-card">
              <div class="principle-icon">
                <i class="bx bx-user-voice"></i>
              </div>
              <h5 class="fw-bold mb-3">Voluntary Participation</h5>
              <p class="text-muted">
                Households voluntarily join PONA HEALTH-X by paying annual premiums.
                Membership is encouraged but not mandatory for informal sector workers.
              </p>
            </div>
          </div>

          <div class="col-md-4 animate-on-scroll">
            <div class="principle-card">
              <div class="principle-icon">
                <i class="bx bx-dollar-circle"></i>
              </div>
              <h5 class="fw-bold mb-3">Affordable Premiums</h5>
              <p class="text-muted">
                Premium rates are set based on household wealth, ensuring affordability.
                The poorest households receive full subsidies from the government.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- History Section -->
    <section id="history" class="py-5">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-badge mb-3 d-inline-block">
            <i class="bx bx-time-five me-2"></i>Our Journey
          </div>
          <h2 class="display-5 fw-bold mb-3">PONA HEALTH-X Development Timeline</h2>
          <p class="lead text-muted">From pilot to nationwide coverage</p>
        </div>

        <div class="timeline">
          <div class="timeline-item animate-on-scroll" v-for="event in timeline" :key="event.year">
            <div class="timeline-marker"></div>
            <div class="timeline-content">
              <div class="timeline-year">{{ event.year }}</div>
              <h5 class="fw-bold mb-2">{{ event.title }}</h5>
              <p class="text-muted mb-0">{{ event.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- How It Works Section -->
    <section id="how-it-works" class="py-5 bg-gradient">
      <div class="container py-5">
        <div class="text-center mb-5 text-white animate-on-scroll">
          <div class="section-badge-light mb-3 d-inline-block">
            <i class="bx bx-cog me-2"></i>Simple Process
          </div>
          <h2 class="display-5 fw-bold mb-3">How PONA HEALTH-X Works</h2>
          <p class="lead">Your journey to healthcare protection in four easy steps</p>
        </div>

        <div class="row g-4 mb-5">
          <div class="col-lg-3 col-md-6 animate-on-scroll" v-for="(step, index) in steps" :key="index">
            <div class="step-card">
              <div class="step-number">{{ index + 1 }}</div>
              <div class="step-icon">
                <i :class="step.icon"></i>
              </div>
              <h5 class="fw-bold mt-4 mb-3">{{ step.title }}</h5>
              <p class="text-muted small mb-0">{{ step.description }}</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-10 mx-auto">
            <div class="process-details-card animate-on-scroll">
              <h4 class="fw-bold mb-4 text-center">Detailed Process Flow</h4>
              <div class="row g-4">
                <div class="col-md-6">
                  <h6 class="fw-bold mb-3"><i class="bx bx-user-plus text-primary me-2"></i>Registration</h6>
                  <ul class="process-list">
                    <li>Visit your local health office or community administration</li>
                    <li>Provide household information and identification</li>
                    <li>Choose a health insurance plan based on your household size</li>
                    <li>Complete registration forms with assistance from health officers</li>
                  </ul>
                </div>
                <div class="col-md-6">
                  <h6 class="fw-bold mb-3"><i class="bx bx-credit-card text-success me-2"></i>Premium Payment</h6>
                  <ul class="process-list">
                    <li>Annual premiums range from FREE (indigent) to standard rates</li>
                    <li>Payment accepted via cash, bank transfer, or mobile money</li>
                    <li>Government subsidizes premiums for poorest households</li>
                    <li>Payment receipts issued immediately upon payment</li>
                  </ul>
                </div>
                <div class="col-md-6">
                  <h6 class="fw-bold mb-3"><i class="bx bx-id-card text-info me-2"></i>Card Issuance</h6>
                  <ul class="process-list">
                    <li>Receive PONA HEALTH-X membership card within 2 weeks</li>
                    <li>Card includes member ID, photo, and household details</li>
                    <li>Valid for one year from date of registration</li>
                    <li>Digital card accessible through member portal</li>
                  </ul>
                </div>
                <div class="col-md-6">
                  <h6 class="fw-bold mb-3"><i class="bx bx-hospital text-warning me-2"></i>Healthcare Access</h6>
                  <ul class="process-list">
                    <li>Present card at any PONA HEALTH-X-contracted health facility</li>
                    <li>Receive services with minimal or no out-of-pocket payment</li>
                    <li>No waiting period - immediate coverage upon enrollment</li>
                    <li>Renewal required annually to maintain coverage</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Benefits Section -->
    <section id="benefits" class="py-5">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-badge mb-3 d-inline-block">
            <i class="bx bx-gift me-2"></i>Member Benefits
          </div>
          <h2 class="display-5 fw-bold mb-3">Why Join PONA HEALTH-X?</h2>
          <p class="lead text-muted">Comprehensive healthcare protection for you and your family</p>
        </div>

        <div class="row g-4">
          <div class="col-lg-4 col-md-6 animate-on-scroll" v-for="(benefit, index) in benefits" :key="index">
            <div class="benefit-card h-100">
              <div class="benefit-icon-wrapper">
                <i :class="benefit.icon"></i>
              </div>
              <h4 class="fw-bold mb-3">{{ benefit.title }}</h4>
              <p class="text-muted mb-0">{{ benefit.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Health Services Coverage Section -->
    <section id="services" class="py-5 bg-light">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-badge mb-3 d-inline-block">
            <i class="bx bx-first-aid me-2"></i>Covered Services
          </div>
          <h2 class="display-5 fw-bold mb-3">What PONA HEALTH-X Covers</h2>
          <p class="lead text-muted">Comprehensive healthcare services for all enrolled members</p>
        </div>

        <div class="row g-4">
          <div class="col-lg-3 col-md-6 animate-on-scroll" v-for="service in healthServices" :key="service.title">
            <div class="service-card">
              <div class="service-icon" :class="service.colorClass">
                <i :class="service.icon"></i>
              </div>
              <h5 class="fw-bold mb-3">{{ service.title }}</h5>
              <ul class="service-list">
                <li v-for="item in service.items" :key="item">
                  <i class="bx bx-check text-success me-2"></i>{{ item }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-lg-10 mx-auto">
            <div class="alert alert-warning animate-on-scroll">
              <h6 class="fw-bold mb-2">
                <i class="bx bx-info-circle me-2"></i>Important Coverage Information
              </h6>
              <ul class="mb-0">
                <li>PONA HEALTH-X covers services at primary health centers, health posts, and district hospitals</li>
                <li>Referral to higher-level facilities requires approval from primary healthcare provider</li>
                <li>Some specialized services may require co-payment</li>
                <li>Cosmetic procedures and non-essential treatments are not covered</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Enrollment Section -->
    <section id="enrollment" class="py-5">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-badge mb-3 d-inline-block">
            <i class="bx bx-user-plus me-2"></i>Join PONA HEALTH-X
          </div>
          <h2 class="display-5 fw-bold mb-3">How to Enroll</h2>
          <p class="lead text-muted">Start your journey to healthcare security today</p>
        </div>

        <div class="row g-4 mb-5">
          <div class="col-lg-4 animate-on-scroll">
            <div class="enrollment-card">
              <div class="enrollment-icon">
                <i class="bx bx-building-house"></i>
              </div>
              <h5 class="fw-bold mb-3">Visit Health Office</h5>
              <p class="text-muted mb-3">
                Go to your nearest health office or community administration during working hours
              </p>
              <p class="small text-muted mb-0">
                <strong>Office Hours:</strong> Monday - Friday, 8:00 AM - 5:00 PM
              </p>
            </div>
          </div>

          <div class="col-lg-4 animate-on-scroll">
            <div class="enrollment-card">
              <div class="enrollment-icon">
                <i class="bx bx-file-blank"></i>
              </div>
              <h5 class="fw-bold mb-3">Required Documents</h5>
              <ul class="document-list">
                <li><i class="bx bx-check-circle text-success me-2"></i>National ID or Local ID</li>
                <li><i class="bx bx-check-circle text-success me-2"></i>Household member list</li>
                <li><i class="bx bx-check-circle text-success me-2"></i>Residence confirmation</li>
                <li><i class="bx bx-check-circle text-success me-2"></i>Recent photo (optional)</li>
              </ul>
            </div>
          </div>

          <div class="col-lg-4 animate-on-scroll">
            <div class="enrollment-card">
              <div class="enrollment-icon">
                <i class="bx bx-money"></i>
              </div>
              <h5 class="fw-bold mb-3">Premium Payment</h5>
              <div class="premium-info">
                <div class="premium-tier mb-2">
                  <strong>Lower Plan:</strong> <span class="text-success">FREE</span>
                  <small class="d-block text-muted">For indigent households</small>
                </div>
                <div class="premium-tier mb-2">
                  <strong>Medium Plan:</strong> <span class="text-primary">Standard Rate</span>
                  <small class="d-block text-muted">For most households</small>
                </div>
                <div class="premium-tier">
                  <strong>Upper Plan:</strong> <span class="text-warning">Premium Rate</span>
                  <small class="d-block text-muted">Extended coverage</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-8 mx-auto text-center animate-on-scroll">
            <div class="cta-card">
              <h4 class="fw-bold mb-3">Ready to Enroll?</h4>
              <p class="mb-4">Contact your nearest health office or call our hotline for assistance</p>
              <div class="d-flex flex-wrap gap-3 justify-content-center">
                <a href="tel:+254700000000" class="btn btn-primary btn-lg">
                  <i class="bx bx-phone me-2"></i>Call Us
                </a>
                <button class="btn btn-outline-primary btn-lg" @click="scrollToSection('contact')">
                  <i class="bx bx-envelope me-2"></i>Contact Us
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Health Facilities Section -->
    <section id="facilities" class="py-5 bg-light">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-badge mb-3 d-inline-block">
            <i class="bx bx-hospital me-2"></i>Our Network
          </div>
          <h2 class="display-5 fw-bold mb-3">PONA HEALTH-X Facilities</h2>
          <p class="lead text-muted">Access quality care at over {{ formatNumber(stats.facilities) }} contracted facilities nationwide</p>
        </div>

        <div class="row g-4 mb-5">
          <div class="col-md-4 animate-on-scroll">
            <div class="facility-card">
              <div class="facility-icon bg-primary">
                <i class="bx bx-clinic"></i>
              </div>
              <h4 class="fw-bold mb-2">{{ formatNumber(stats.healthPosts) }}+</h4>
              <h6 class="text-muted">Health Posts</h6>
              <p class="small text-muted mb-0">Community-level primary care</p>
            </div>
          </div>
          <div class="col-md-4 animate-on-scroll">
            <div class="facility-card">
              <div class="facility-icon bg-success">
                <i class="bx bx-plus-medical"></i>
              </div>
              <h4 class="fw-bold mb-2">{{ formatNumber(stats.healthCenters) }}+</h4>
              <h6 class="text-muted">Health Centers</h6>
              <p class="small text-muted mb-0">District-level care facilities</p>
            </div>
          </div>
          <div class="col-md-4 animate-on-scroll">
            <div class="facility-card">
              <div class="facility-icon bg-info">
                <i class="bx bx-hospital"></i>
              </div>
              <h4 class="fw-bold mb-2">{{ formatNumber(stats.hospitals) }}+</h4>
              <h6 class="text-muted">Hospitals</h6>
              <p class="small text-muted mb-0">District and referral hospitals</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-10 mx-auto animate-on-scroll">
            <div class="facility-search-card">
              <h5 class="fw-bold mb-4 text-center">Find a Health Facility Near You</h5>
              <div class="row g-3">
                <div class="col-md-4">
                  <select class="form-select">
                    <option selected>Select Region</option>
                    <option>Region 1</option>
                    <option>Region 2</option>
                    <option>Region 3</option>
                    <option>Region 4</option>
                    <option>Region 5</option>
                    <option>Others</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <select class="form-select">
                    <option selected>Select Zone/Subcity</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <select class="form-select">
                    <option selected>Select District</option>
                  </select>
                </div>
                <div class="col-12">
                  <button class="btn btn-primary w-100">
                    <i class="bx bx-search me-2"></i>Search Facilities
                  </button>
                </div>
              </div>
              <div class="text-center mt-3">
                <p class="small text-muted mb-0">
                  <i class="bx bx-info-circle me-1"></i>
                  All listed facilities accept PONA HEALTH-X members
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FAQs Section -->
    <section id="faqs" class="py-5">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-badge mb-3 d-inline-block">
            <i class="bx bx-help-circle me-2"></i>Common Questions
          </div>
          <h2 class="display-5 fw-bold mb-3">Frequently Asked Questions</h2>
          <p class="lead text-muted">Everything you need to know about PONA HEALTH-X</p>
        </div>

        <div class="row">
          <div class="col-lg-10 mx-auto">
            <div class="accordion" id="faqAccordion">
              <div class="accordion-item animate-on-scroll" v-for="(faq, index) in faqs" :key="index">
                <h2 class="accordion-header" :id="'heading' + index">
                  <button class="accordion-button" :class="{ collapsed: index !== 0 }"
                          type="button" data-bs-toggle="collapse"
                          :data-bs-target="'#collapse' + index"
                          :aria-expanded="index === 0"
                          :aria-controls="'collapse' + index">
                    {{ faq.question }}
                  </button>
                </h2>
                <div :id="'collapse' + index"
                     class="accordion-collapse collapse"
                     :class="{ show: index === 0 }"
                     :aria-labelledby="'heading' + index"
                     data-bs-parent="#faqAccordion">
                  <div class="accordion-body">
                    {{ faq.answer }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Contact Section -->
    <section id="contact" class="py-5 bg-light">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-badge mb-3 d-inline-block">
            <i class="bx bx-phone me-2"></i>Get In Touch
          </div>
          <h2 class="display-5 fw-bold mb-3">Contact Us</h2>
          <p class="lead text-muted">We're here to answer your questions and help you enroll</p>
        </div>

        <div class="row g-4 mb-5">
          <div class="col-lg-4 animate-on-scroll" v-for="contact in contacts" :key="contact.title">
            <div class="contact-card text-center h-100">
              <div class="contact-icon mx-auto mb-4">
                <i :class="contact.icon"></i>
              </div>
              <h5 class="fw-bold mb-3">{{ contact.title }}</h5>
              <p class="text-muted mb-3">{{ contact.description }}</p>
              <a :href="contact.link" class="btn btn-outline-primary">
                {{ contact.action }}
                <i class="bx bx-right-arrow-alt ms-2"></i>
              </a>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-10 mx-auto animate-on-scroll">
            <div class="regional-offices-card">
              <h5 class="fw-bold mb-4 text-center">Regional PONA HEALTH-X Offices</h5>
              <div class="row g-3">
                <div class="col-md-6" v-for="office in regionalOffices" :key="office.region">
                  <div class="office-item">
                    <h6 class="fw-bold mb-2">{{ office.region }}</h6>
                    <p class="small text-muted mb-1">
                      <i class="bx bx-map me-2"></i>{{ office.address }}
                    </p>
                    <p class="small text-muted mb-0">
                      <i class="bx bx-phone me-2"></i>{{ office.phone }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Member Portal CTA -->
    <section class="py-5 bg-primary text-white">
      <div class="container py-5">
        <div class="row align-items-center">
          <div class="col-lg-8 animate-on-scroll">
            <h2 class="display-5 fw-bold mb-3 text-white">Already a PONA HEALTH-X Member?</h2>
            <p class="lead mb-4 mb-lg-0">
              Access your member portal to view coverage, track payments, manage beneficiaries,
              and download your insurance card. Available 24/7 from anywhere.
            </p>
          </div>
          <div class="col-lg-4 text-lg-end animate-on-scroll">
            <button class="btn btn-light btn-lg px-5 mb-3 w-100 w-lg-auto" @click="goToPage('login')">
              <i class="bx bx-user-circle me-2"></i>
              Member Portal
            </button>
            <button class="btn btn-outline-light btn-lg px-5 w-100 w-lg-auto" @click="goToPage('login')">
              <i class="bx bx-briefcase me-2"></i>
              Staff Login
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="bg-dark text-white py-5">
      <div class="container">
        <div class="row g-4">
          <div class="col-lg-4">
            <div class="d-flex align-items-center mb-4">
              <img src="https://pona.paysol.africa/logos/pona.png" alt="PONA HEALTH-X Logo" height="40" class="me-3">
              <div>
                <div class="fw-bold">PONA HEALTH-X</div>
                <div class="small">Community-Based Health Insurance</div>
              </div>
            </div>
            <p class="text-white-50 mb-4">
              Working towards universal health coverage through community-based health insurance.
              Ensuring everyone has access to quality, affordable healthcare.
            </p>
            <div class="social-links">
              <a href="#" class="text-white-50 me-3"><i class="bx bxl-facebook-circle fs-4"></i></a>
              <a href="#" class="text-white-50 me-3"><i class="bx bxl-twitter fs-4"></i></a>
              <a href="#" class="text-white-50 me-3"><i class="bx bxl-linkedin-square fs-4"></i></a>
              <a href="#" class="text-white-50"><i class="bx bxl-youtube fs-4"></i></a>
            </div>
          </div>

          <div class="col-lg-2 col-md-6">
            <h6 class="fw-bold mb-3 text-white">About</h6>
            <ul class="list-unstyled">
              <li class="mb-2"><a href="#ministry" class="text-white-50 text-decoration-none">About PONA HEALTH-X</a></li>
              <li class="mb-2"><a href="#pona-overview" class="text-white-50 text-decoration-none">Overview</a></li>
              <li class="mb-2"><a href="#history" class="text-white-50 text-decoration-none">Our History</a></li>
              <li class="mb-2"><a href="#vision" class="text-white-50 text-decoration-none">Vision & Mission</a></li>
            </ul>
          </div>

          <div class="col-lg-2 col-md-6">
            <h6 class="fw-bold mb-3 text-white">Programs</h6>
            <ul class="list-unstyled">
              <li class="mb-2"><a href="#how-it-works" class="text-white-50 text-decoration-none">How It Works</a></li>
              <li class="mb-2"><a href="#benefits" class="text-white-50 text-decoration-none">Benefits</a></li>
              <li class="mb-2"><a href="#services" class="text-white-50 text-decoration-none">Health Services</a></li>
              <li class="mb-2"><a href="#enrollment" class="text-white-50 text-decoration-none">Enrollment</a></li>
            </ul>
          </div>

          <div class="col-lg-2 col-md-6">
            <h6 class="fw-bold mb-3 text-white">Resources</h6>
            <ul class="list-unstyled">
              <li class="mb-2"><a href="#facilities" class="text-white-50 text-decoration-none">Find Facilities</a></li>
              <li class="mb-2"><a href="#faqs" class="text-white-50 text-decoration-none">FAQs</a></li>
              <li class="mb-2"><a @click="goToMemberLogin" class="text-white-50 text-decoration-none cursor-pointer">Member Portal</a></li>
              <li class="mb-2"><a href="#contact" class="text-white-50 text-decoration-none">Contact Us</a></li>
            </ul>
          </div>

          <div class="col-lg-2 col-md-6">
            <h6 class="fw-bold mb-3 text-white">Quick Links</h6>
            <ul class="list-unstyled">
              <li class="mb-2"><a href="#" class="text-white-50 text-decoration-none">Downloads</a></li>
              <li class="mb-2"><a href="#" class="text-white-50 text-decoration-none">Publications</a></li>
              <li class="mb-2"><a href="#" class="text-white-50 text-decoration-none">News & Updates</a></li>
              <li class="mb-2"><a href="#" class="text-white-50 text-decoration-none">Careers</a></li>
            </ul>
          </div>
        </div>

        <hr class="my-4 bg-white opacity-25">

        <div class="row align-items-center">
          <div class="col-md-6 text-center text-md-start">
            <p class="mb-0 text-white-50 small">
              © 2025 PONA HEALTH-X. All rights reserved.
            </p>
          </div>
          <div class="col-md-6 text-center text-md-end">
            <p class="mb-0 text-white-50 small">
              <a href="#" class="text-white-50 text-decoration-none me-3">Privacy Policy</a>
              <a href="#" class="text-white-50 text-decoration-none me-3">Terms of Service</a>
              <a href="#" class="text-white-50 text-decoration-none">Accessibility</a>
            </p>
          </div>
        </div>
      </div>
    </footer>

    <!-- Scroll to Top Button -->
    <button class="scroll-top-btn" @click="scrollToTop" v-show="showScrollTop">
      <i class="bx bx-chevron-up"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'PonaHealthWebsite',

  data() {
    return {
      showScrollTop: false,

      stats: {
        members: 15,
        facilities: 3500,
        coverage: 45,
        regions: 11,
        healthPosts: 16000,
        healthCenters: 3547,
        hospitals: 311
      },

      timeline: [
        {
          year: '2018',
          title: 'PONA HEALTH-X Pilot Launch',
          description: 'Pilot program launched in select districts to test community-based health financing.'
        },
        {
          year: '2019',
          title: 'National Rollout',
          description: 'After successful pilot results, PONA HEALTH-X scheme officially launched nationwide, targeting informal sector workers and rural communities.'
        },
        {
          year: '2020',
          title: 'Major Expansion',
          description: 'Program expanded to cover over 5 million households. Digital registration systems introduced in urban areas.'
        },
        {
          year: '2021',
          title: 'Health Sector Reform',
          description: 'PONA HEALTH-X integrated into broader health sector transformation plan. Enhanced service packages and quality standards introduced.'
        },
        {
          year: '2022',
          title: 'COVID-19 Response',
          description: 'Special provisions made for PONA HEALTH-X members during pandemic. Telemedicine services added to coverage package.'
        },
        {
          year: '2023',
          title: 'Digital Transformation',
          description: 'Launch of member portal and mobile app. Digital cards and online payment systems rolled out nationwide.'
        },
        {
          year: '2025',
          title: 'Universal Coverage Goal',
          description: 'Target to reach 80% coverage of informal sector by 2025, working towards universal health coverage for all.'
        }
      ],

      steps: [
        {
          icon: 'bx bx-user-plus',
          title: 'Register',
          description: 'Visit your local health office with required documents and household information to begin enrollment process.'
        },
        {
          icon: 'bx bx-credit-card',
          title: 'Pay Premium',
          description: 'Pay your annual premium based on selected plan. Multiple payment options available including mobile money.'
        },
        {
          icon: 'bx bx-id-card',
          title: 'Get Your Card',
          description: 'Receive your PONA HEALTH-X membership card and access digital card through our member portal.'
        },
        {
          icon: 'bx bx-hospital',
          title: 'Access Care',
          description: 'Visit any contracted health facility and present your card for covered healthcare services.'
        }
      ],

      benefits: [
        {
          icon: 'bx bx-dollar-circle text-success',
          title: 'Financial Protection',
          description: 'Protect your family from catastrophic health expenditures. Affordable premiums starting from FREE for poorest households, with government subsidies available.'
        },
        {
          icon: 'bx bx-heart text-danger',
          title: 'Comprehensive Coverage',
          description: 'Access to outpatient care, inpatient services, essential medicines, maternity care, emergency treatment, and diagnostic services at contracted facilities.'
        },
        {
          icon: 'bx bx-user-plus text-primary',
          title: 'Family Coverage',
          description: 'One membership covers your entire household including spouse and children under 18. Additional members can be added at subsidized rates.'
        },
        {
          icon: 'bx bx-time-five text-warning',
          title: 'Immediate Coverage',
          description: 'No waiting period for most services. Start accessing healthcare immediately upon enrollment and premium payment.'
        },
        {
          icon: 'bx bx-map text-info',
          title: 'Wide Network',
          description: 'Access care at over 3,500 contracted health facilities nationwide including health posts, health centers, and hospitals.'
        },
        {
          icon: 'bx bx-mobile-alt text-purple',
          title: 'Digital Access',
          description: 'Manage your insurance online through our member portal. View coverage, track payments, download digital cards, and update information 24/7.'
        },
        {
          icon: 'bx bx-trending-up text-success',
          title: 'Annual Renewal',
          description: 'Simple annual renewal process. Flexible payment schedules and reminder notifications to maintain continuous coverage.'
        },
        {
          icon: 'bx bx-shield-check text-primary',
          title: 'Quality Assurance',
          description: 'All contracted facilities meet quality standards. Regular monitoring and evaluation ensures quality service delivery.'
        },
        {
          icon: 'bx bx-group text-info',
          title: 'Community Solidarity',
          description: 'Join millions in a collective health protection scheme based on solidarity, equity, and community participation.'
        }
      ],

      healthServices: [
        {
          title: 'Outpatient Care',
          icon: 'bx bx-clinic',
          colorClass: 'bg-primary',
          items: ['Consultations', 'Examinations', 'Minor procedures', 'Prescriptions', 'Preventive care']
        },
        {
          title: 'Inpatient Care',
          icon: 'bx bx-bed',
          colorClass: 'bg-success',
          items: ['Hospital admission', 'Medical treatment', 'Surgical procedures', 'Nursing care', 'Meals & accommodation']
        },
        {
          title: 'Maternity Services',
          icon: 'bx bx-happy-heart-eyes',
          colorClass: 'bg-danger',
          items: ['Antenatal care', 'Delivery services', 'Postnatal care', 'Family planning', 'Newborn care']
        },
        {
          title: 'Emergency Care',
          icon: 'bx bx-first-aid',
          colorClass: 'bg-warning',
          items: ['Emergency treatment', 'Ambulance services', 'Trauma care', 'Urgent procedures', '24/7 availability']
        },
        {
          title: 'Laboratory Services',
          icon: 'bx bx-test-tube',
          colorClass: 'bg-info',
          items: ['Blood tests', 'Urine analysis', 'Microscopy', 'Basic diagnostics', 'Lab investigations']
        },
        {
          title: 'Pharmacy',
          icon: 'bx bx-capsule',
          colorClass: 'bg-purple',
          items: ['Essential medicines', 'Generic drugs', 'Antibiotics', 'Chronic disease meds', 'Prescribed medications']
        },
        {
          title: 'Imaging Services',
          icon: 'bx bx-scan',
          colorClass: 'bg-teal',
          items: ['X-rays', 'Ultrasound', 'Basic radiology', 'Diagnostic imaging', 'Referred scans']
        },
        {
          title: 'Dental Care',
          icon: 'bx bx-happy-beaming',
          colorClass: 'bg-orange',
          items: ['Basic dental care', 'Tooth extraction', 'Oral examination', 'Pain management', 'Dental hygiene']
        }
      ],

      faqs: [
        {
          question: 'Who is eligible to join PONA HEALTH-X?',
          answer: 'PONA HEALTH-X is designed for informal sector workers and rural communities who are not covered by formal employment-based health insurance. This includes farmers, self-employed individuals, daily laborers, small business owners, and their families. Members must reside in the catchment area of participating health facilities.'
        },
        {
          question: 'How much does PONA HEALTH-X membership cost?',
          answer: 'Annual premiums vary depending on your household wealth status and selected plan. The poorest households (indigent) receive full government subsidy and pay nothing. Most households pay a standard rate for the medium plan. Health Extension Workers assess household economic status to determine appropriate premium level.'
        },
        {
          question: 'What services are covered by PONA HEALTH-X?',
          answer: 'PONA HEALTH-X covers essential healthcare services including outpatient consultations, inpatient care, essential medicines, laboratory tests, basic imaging, maternity services, emergency care, and preventive services. Coverage is provided at health posts, health centers, and district hospitals. Some specialized services may require referral and co-payment.'
        },
        {
          question: 'Can I choose my healthcare provider?',
          answer: 'Yes, you can access care at any PONA HEALTH-X-contracted health facility in your district. However, you must first visit your designated primary healthcare facility (health post or health center). For specialized care at higher-level facilities, you need a referral from your primary provider.'
        },
        {
          question: 'How long does coverage last?',
          answer: 'PONA HEALTH-X coverage is valid for one year from the date of enrollment and premium payment. You must renew your membership annually by paying the premium before expiry to maintain continuous coverage. Grace periods may apply depending on regional policies.'
        },
        {
          question: 'What happens if I cannot afford the premium?',
          answer: 'If you cannot afford the premium, contact your local health office for assessment. Indigent households identified through community-based wealth ranking receive full government subsidy and join PONA HEALTH-X for free. Partial subsidies may be available for other vulnerable groups.'
        },
        {
          question: 'Are there waiting periods before I can use services?',
          answer: 'There is generally no waiting period for PONA HEALTH-X coverage. You can start accessing covered services immediately after enrollment and premium payment. However, some regions may have short waiting periods for certain elective procedures. Emergency care is always available immediately.'
        },
        {
          question: 'Can I add family members later?',
          answer: 'Yes, household members can be added during annual renewal. However, entire households must enroll together initially - partial household enrollment is not permitted. This ensures solidarity and prevents adverse selection where only sick family members join.'
        },
        {
          question: 'What if I move to a different district?',
          answer: 'If you permanently relocate, you need to transfer your PONA HEALTH-X membership to your new district of residence. Visit the health office in your new location to initiate the transfer process. Your coverage continues during the transfer period.'
        },
        {
          question: 'How do I file a complaint or provide feedback?',
          answer: 'Complaints can be filed at your health facility, district health office, or regional PONA HEALTH-X office. You can also call our hotline. PONA HEALTH-X has established grievance redress mechanisms to address member concerns promptly and fairly.'
        }
      ],

      contacts: [
        {
          icon: 'bx bx-phone-call',
          title: 'Call Us',
          description: 'PONA HEALTH-X hotline available 24/7',
          action: 'Call Now',
          link: 'tel:+254700000000'
        },
        {
          icon: 'bx bx-envelope',
          title: 'Email Us',
          description: 'Send your questions and feedback',
          action: 'Send Email',
          link: 'mailto:info@ponahealth.com'
        },
        {
          icon: 'bx bx-map-pin',
          title: 'Visit Us',
          description: 'Find your nearest PONA HEALTH-X office',
          action: 'Find Office',
          link: '#facilities'
        }
      ],

      regionalOffices: [
        { region: 'Headquarters', address: 'Main Office, City Center', phone: '+254-XXX-XXX-XXXX' },
        { region: 'Region 1', address: 'Regional Health Bureau', phone: '+254-XXX-XXX-XXXX' },
        { region: 'Region 2', address: 'Regional Health Bureau', phone: '+254-XXX-XXX-XXXX' },
        { region: 'Region 3', address: 'Regional Health Bureau', phone: '+254-XXX-XXX-XXXX' },
        { region: 'Region 4', address: 'Regional Health Bureau', phone: '+254-XXX-XXX-XXXX' },
        { region: 'Region 5', address: 'Regional Health Bureau', phone: '+254-XXX-XXX-XXXX' }
      ]
    };
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.observeElements();
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    observeElements() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      document.querySelectorAll('.animate-on-scroll').forEach(el => {
        observer.observe(el);
      });
    },

    goToMemberLogin() {
      this.goToPage('member-login')
    },

    goToStaffLogin() {
      this.goToPage('login')
    },

    goToPage(page) {
      this.$router.push(page);
    },

    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 80; // Account for fixed navbar
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    },

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    handleScroll() {
      this.showScrollTop = window.pageYOffset > 300;
    },

    formatNumber(num) {
      return new Intl.NumberFormat().format(num);
    }
  }
};
</script>

<style scoped>
/* ========================================================================= */
/* MODERN PROFESSIONAL STYLES - PONA HEALTH-X */
/* ========================================================================= */

/* General Styles */
.pona-website {
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  overflow-x: hidden;
  background: #fafbfc;
}

.cursor-pointer {
  cursor: pointer;
}

/* ========================================================================= */
/* NAVIGATION - MODERN GLASSMORPHISM */
/* ========================================================================= */
.navbar {
  padding: 1rem 0;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.05);
}

.navbar.scrolled {
  background: rgba(255, 255, 255, 0.98) !important;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.12);
}

.brand-title {
  font-weight: 800;
  font-size: 1.1rem;
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1.2;
}

.brand-subtitle {
  font-size: 0.75rem;
  color: #6c757d;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.nav-link {
  font-weight: 600;
  color: #495057 !important;
  padding: 0.5rem 1rem !important;
  transition: all 0.3s ease;
  position: relative;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 3px;
  background: linear-gradient(90deg, #2c5aa0, #4a90e2);
  transform: translateX(-50%);
  transition: width 0.3s ease;
  border-radius: 3px 3px 0 0;
}

.nav-link:hover::after {
  width: 80%;
}

.nav-link:hover {
  color: #2c5aa0 !important;
  transform: translateY(-2px);
}

.dropdown-menu {
  border: none;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  border-radius: 1rem;
  padding: 0.5rem;
}

.dropdown-item {
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  transition: all 0.3s ease;
  font-weight: 500;
}

.dropdown-item:hover {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  color: #2c5aa0;
  transform: translateX(5px);
}

/* ========================================================================= */
/* HERO SECTION - DRAMATIC & MODERN */
/* ========================================================================= */
.hero-section {
  position: relative;
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 50%, #4a90e2 100%);
  overflow: hidden;
  margin-top: 70px;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
      radial-gradient(circle at 20% 50%, rgba(74, 144, 226, 0.4) 0%, transparent 50%),
      radial-gradient(circle at 80% 80%, rgba(44, 90, 160, 0.3) 0%, transparent 50%),
      url('data:image/svg+xml,<svg width="100" height="100" xmlns="http://www.w3.org/2000/svg"><defs><pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse"><path d="M 40 0 L 0 0 0 40" fill="none" stroke="rgba(255,255,255,0.03)" stroke-width="1"/></pattern></defs><rect width="100%" height="100%" fill="url(%23grid)" /></svg>');
  animation: heroShift 20s ease-in-out infinite;
}

@keyframes heroShift {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(20px, 20px); }
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 30% 40%, rgba(255, 255, 255, 0.1) 0%, transparent 60%);
}

.hero-content {
  position: relative;
  z-index: 2;
}

.hero-badge {
  display: inline-block;
  padding: 0.75rem 2rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50px;
  font-weight: 700;
  font-size: 0.95rem;
  backdrop-filter: blur(20px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.stat-card {
  text-align: center;
  padding: 1.5rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 1rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.stat-card:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 900;
  color: white;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.stat-label {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;
}

.hero-image-container {
  position: relative;
}

.hero-image-container::before {
  content: '';
  position: absolute;
  top: -20px;
  right: -20px;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  border-radius: 2rem;
  z-index: -1;
}

.hero-image-container img {
  transition: all 0.5s ease;
  border-radius: 1.5rem;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.hero-image-container:hover img {
  transform: scale(1.03) rotate(1deg);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.4);
}

/* ========================================================================= */
/* SECTION BADGES - MODERN PILLS */
/* ========================================================================= */
.section-badge,
.section-badge-light {
  display: inline-block;
  padding: 0.75rem 2rem;
  border-radius: 50px;
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.section-badge {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  color: #2c5aa0;
  border: 2px solid #90caf9;
}

.section-badge:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(44, 90, 160, 0.3);
}

.section-badge-light {
  background: rgba(255, 255, 255, 0.25);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
}

.section-badge-light:hover {
  background: rgba(255, 255, 255, 0.35);
  transform: translateY(-3px);
}

/* ========================================================================= */
/* MINISTRY HIGHLIGHTS - MODERN CARDS */
/* ========================================================================= */
.ministry-highlight {
  padding: 2rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 1rem;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
}

.ministry-highlight::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #2c5aa0, #4a90e2);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.ministry-highlight:hover::before {
  transform: scaleX(1);
}

.ministry-highlight:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(44, 90, 160, 0.2);
  border-color: #e3f2fd;
}

/* ========================================================================= */
/* VISION & MISSION - ELEGANT CARDS */
/* ========================================================================= */
.vision-card,
.mission-card {
  padding: 3rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 1.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  border-left: 6px solid;
  border-image: linear-gradient(180deg, #2c5aa0, #4a90e2) 1;
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
}

.vision-card::after,
.mission-card::after {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(74, 144, 226, 0.03) 0%, transparent 70%);
  transition: all 0.6s ease;
}

.vision-card:hover::after,
.mission-card:hover::after {
  top: -100%;
  right: -100%;
}

.vision-card:hover,
.mission-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 60px rgba(44, 90, 160, 0.15);
}

.vision-icon,
.mission-icon {
  width: 90px;
  height: 90px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  box-shadow: 0 8px 25px rgba(44, 90, 160, 0.15);
  transition: all 0.3s ease;
}

.vision-card:hover .vision-icon,
.mission-card:hover .mission-icon {
  transform: rotate(5deg) scale(1.1);
}

.vision-icon i,
.mission-icon i {
  font-size: 2.8rem;
  color: #2c5aa0;
}

.mission-list {
  list-style: none;
  padding: 0;
}

.mission-list li {
  padding: 1rem 0;
  display: flex;
  align-items: start;
  transition: all 0.3s ease;
}

.mission-list li:hover {
  transform: translateX(10px);
  color: #2c5aa0;
}

/* ========================================================================= */
/* PONA INTRO CARD - PREMIUM */
/* ========================================================================= */
.pona-intro-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 3rem;
  border-radius: 1.5rem;
  box-shadow: 0 10px 50px rgba(0, 0, 0, 0.08);
  border: 3px solid transparent;
  background-clip: padding-box;
  position: relative;
}

.pona-intro-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 1.5rem;
  padding: 3px;
  background: linear-gradient(135deg, #2c5aa0, #4a90e2);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  z-index: -1;
}

/* ========================================================================= */
/* PRINCIPLE CARDS - MODERN 3D */
/* ========================================================================= */
.principle-card {
  padding: 2.5rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 1.5rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: center;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.principle-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: linear-gradient(90deg, #2c5aa0, #4a90e2, #2c5aa0);
  background-size: 200% 100%;
  animation: shimmer 3s linear infinite;
}

@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

.principle-card:hover {
  transform: translateY(-15px) scale(1.02);
  box-shadow: 0 20px 60px rgba(44, 90, 160, 0.2);
}

.principle-icon {
  width: 90px;
  height: 90px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 2rem;
  box-shadow: 0 10px 30px rgba(44, 90, 160, 0.15);
  transition: all 0.4s ease;
}

.principle-card:hover .principle-icon {
  transform: rotateY(180deg);
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
}

.principle-card:hover .principle-icon i {
  color: white;
}

.principle-icon i {
  font-size: 2.8rem;
  color: #2c5aa0;
  transition: all 0.4s ease;
}

/* ========================================================================= */
/* TIMELINE - MODERN VERTICAL */
/* ========================================================================= */
.timeline {
  position: relative;
  padding: 3rem 0;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 30px;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, #2c5aa0 0%, #4a90e2 50%, #2c5aa0 100%);
  border-radius: 2px;
  box-shadow: 0 0 20px rgba(44, 90, 160, 0.3);
}

.timeline-item {
  position: relative;
  padding-left: 90px;
  margin-bottom: 4rem;
}

.timeline-marker {
  position: absolute;
  left: 19px;
  top: 5px;
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  border: 5px solid white;
  border-radius: 50%;
  z-index: 2;
  box-shadow: 0 0 0 4px rgba(44, 90, 160, 0.2), 0 4px 15px rgba(44, 90, 160, 0.3);
  transition: all 0.3s ease;
}

.timeline-item:hover .timeline-marker {
  transform: scale(1.3);
  box-shadow: 0 0 0 8px rgba(44, 90, 160, 0.2), 0 8px 25px rgba(44, 90, 160, 0.4);
}

.timeline-content {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 2rem;
  border-radius: 1.5rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
  border-left: 4px solid transparent;
}

.timeline-item:hover .timeline-content {
  transform: translateX(10px);
  box-shadow: 0 15px 50px rgba(44, 90, 160, 0.15);
  border-left-color: #4a90e2;
}

.timeline-year {
  display: inline-block;
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  color: white;
  padding: 0.5rem 1.5rem;
  border-radius: 30px;
  font-weight: 800;
  margin-bottom: 1rem;
  box-shadow: 0 4px 15px rgba(44, 90, 160, 0.3);
  font-size: 1.1rem;
}

/* ========================================================================= */
/* STEP CARDS - 3D ELEVATED */
/* ========================================================================= */
.step-card {
  padding: 2.5rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 1.5rem;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  position: relative;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  height: 100%;
  border: 2px solid transparent;
}

.step-card:hover {
  transform: translateY(-20px) scale(1.03);
  box-shadow: 0 25px 60px rgba(44, 90, 160, 0.2);
  border-color: #e3f2fd;
}

.step-number {
  position: absolute;
  top: -25px;
  right: 25px;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  font-size: 1.5rem;
  box-shadow: 0 8px 25px rgba(44, 90, 160, 0.4);
  border: 5px solid white;
  transition: all 0.3s ease;
}

.step-card:hover .step-number {
  transform: rotate(360deg) scale(1.1);
}

.step-icon {
  width: 90px;
  height: 90px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 1.5rem;
  box-shadow: 0 10px 30px rgba(44, 90, 160, 0.15);
  transition: all 0.4s ease;
}

.step-card:hover .step-icon {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  transform: rotateY(360deg);
}

.step-icon i {
  font-size: 2.8rem;
  color: #2c5aa0;
  transition: all 0.4s ease;
}

.step-card:hover .step-icon i {
  color: white;
}

/* ========================================================================= */
/* PROCESS DETAILS - PREMIUM CARD */
/* ========================================================================= */
.process-details-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 3rem;
  border-radius: 1.5rem;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.1);
  border: 3px solid #e3f2fd;
}

.process-list {
  list-style: none;
  padding-left: 0;
}

.process-list li {
  padding: 0.75rem 0;
  padding-left: 2rem;
  position: relative;
  transition: all 0.3s ease;
}

.process-list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: white;
  background: linear-gradient(135deg, #2c5aa0, #4a90e2);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  font-size: 0.8rem;
  box-shadow: 0 4px 10px rgba(44, 90, 160, 0.3);
}

.process-list li:hover {
  transform: translateX(10px);
  color: #2c5aa0;
}

/* ========================================================================= */
/* BENEFIT CARDS - HOVER EFFECTS */
/* ========================================================================= */
.benefit-card {
  padding: 2.5rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 1.5rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
}

.benefit-card::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(74, 144, 226, 0.1) 0%, transparent 70%);
  opacity: 0;
  transition: opacity 0.4s ease;
}

.benefit-card:hover::before {
  opacity: 1;
}

.benefit-card:hover {
  transform: translateY(-15px) scale(1.02);
  box-shadow: 0 20px 60px rgba(44, 90, 160, 0.2);
  border-color: #e3f2fd;
}

.benefit-icon-wrapper {
  width: 90px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 10px 30px rgba(44, 90, 160, 0.15);
  transition: all 0.4s ease;
}

.benefit-card:hover .benefit-icon-wrapper {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  transform: scale(1.1) rotate(5deg);
}

.benefit-icon-wrapper i {
  font-size: 2.8rem;
  transition: all 0.4s ease;
}

.benefit-card:hover .benefit-icon-wrapper i {
  color: white !important;
}

/* ========================================================================= */
/* SERVICE CARDS - COLORFUL & MODERN */
/* ========================================================================= */
.service-card {
  padding: 2.5rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 1.5rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
  height: 100%;
  border-top: 5px solid transparent;
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.12);
}

.service-icon {
  width: 80px;
  height: 80px;
  border-radius: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  transition: all 0.4s ease;
}

.service-card:hover .service-icon {
  transform: scale(1.15) rotate(-5deg);
}

.service-icon i {
  font-size: 2.5rem;
  color: white;
}

.service-list {
  list-style: none;
  padding: 0;
}

.service-list li {
  padding: 0.75rem 0;
  display: flex;
  align-items: start;
  font-size: 0.95rem;
  transition: all 0.3s ease;
}

.service-list li:hover {
  transform: translateX(8px);
  color: #2c5aa0;
}

/* ========================================================================= */
/* ENROLLMENT CARDS - INTERACTIVE */
/* ========================================================================= */
.enrollment-card {
  padding: 2.5rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 1.5rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  height: 100%;
  transition: all 0.4s ease;
  border: 2px solid transparent;
}

.enrollment-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(44, 90, 160, 0.15);
  border-color: #e3f2fd;
}

.enrollment-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  box-shadow: 0 8px 25px rgba(44, 90, 160, 0.15);
  transition: all 0.3s ease;
}

.enrollment-card:hover .enrollment-icon {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  transform: scale(1.1);
}

.enrollment-icon i {
  font-size: 2.5rem;
  color: #2c5aa0;
  transition: all 0.3s ease;
}

.enrollment-card:hover .enrollment-icon i {
  color: white;
}

.document-list {
  list-style: none;
  padding: 0;
}

.document-list li {
  padding: 0.75rem 0;
  transition: all 0.3s ease;
}

.document-list li:hover {
  transform: translateX(10px);
  color: #2c5aa0;
}

.premium-tier {
  padding: 1rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 0.75rem;
  border-left: 4px solid #2c5aa0;
  transition: all 0.3s ease;
}

.premium-tier:hover {
  transform: translateX(8px);
  box-shadow: 0 4px 15px rgba(44, 90, 160, 0.15);
}

.cta-card {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  padding: 3rem;
  border-radius: 1.5rem;
  box-shadow: 0 15px 50px rgba(44, 90, 160, 0.2);
  border: 3px solid rgba(255, 255, 255, 0.5);
}

/* ========================================================================= */
/* FACILITY CARDS - STATS DISPLAY */
/* ========================================================================= */
.facility-card {
  padding: 2.5rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 1.5rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  text-align: center;
  transition: all 0.4s ease;
  border: 2px solid transparent;
}

.facility-card:hover {
  transform: translateY(-10px) scale(1.03);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
  border-color: #e3f2fd;
}

.facility-icon {
  width: 90px;
  height: 90px;
  border-radius: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  transition: all 0.4s ease;
}

.facility-card:hover .facility-icon {
  transform: scale(1.15) rotate(5deg);
}

.facility-icon i {
  font-size: 2.8rem;
  color: white;
}

.facility-search-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 2.5rem;
  border-radius: 1.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  border: 2px solid #e3f2fd;
}

.form-select {
  border: 2px solid #e9ecef;
  border-radius: 0.75rem;
  padding: 0.75rem 1rem;
  transition: all 0.3s ease;
  font-weight: 500;
}

.form-select:focus {
  border-color: #2c5aa0;
  box-shadow: 0 0 0 0.2rem rgba(44, 90, 160, 0.15);
}

/* ========================================================================= */
/* CONTACT CARDS - MODERN HOVER */
/* ========================================================================= */
.contact-card {
  padding: 2.5rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 1.5rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
  border: 2px solid transparent;
}

.contact-card:hover {
  transform: translateY(-15px);
  box-shadow: 0 20px 60px rgba(44, 90, 160, 0.2);
  border-color: #e3f2fd;
}

.contact-icon {
  width: 90px;
  height: 90px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 30px rgba(44, 90, 160, 0.15);
  transition: all 0.4s ease;
}

.contact-card:hover .contact-icon {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  transform: scale(1.15) rotate(360deg);
}

.contact-icon i {
  font-size: 2.8rem;
  color: #2c5aa0;
  transition: all 0.4s ease;
}

.contact-card:hover .contact-icon i {
  color: white;
}

.regional-offices-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 2.5rem;
  border-radius: 1.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  border: 2px solid #e3f2fd;
}

.office-item {
  padding: 1.5rem;
  background: white;
  border-radius: 1rem;
  border-left: 5px solid #2c5aa0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.office-item:hover {
  transform: translateX(10px);
  box-shadow: 0 8px 25px rgba(44, 90, 160, 0.15);
}

/* ========================================================================= */
/* ACCORDION - MODERN FAQ */
/* ========================================================================= */
.accordion-item {
  margin-bottom: 1.5rem;
  border: none;
  border-radius: 1rem !important;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.accordion-item:hover {
  box-shadow: 0 8px 30px rgba(44, 90, 160, 0.15);
}

.accordion-button {
  font-weight: 700;
  color: #2c5aa0;
  background-color: white;
  padding: 1.5rem;
  font-size: 1.05rem;
  border: none;
}

.accordion-button:not(.collapsed) {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  color: #1e3f70;
  box-shadow: none;
}

.accordion-button:focus {
  box-shadow: none;
  border-color: transparent;
}

.accordion-button::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%232c5aa0'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
}

.accordion-body {
  padding: 1.5rem;
  background: white;
  line-height: 1.8;
}

/* ========================================================================= */
/* BUTTONS - PREMIUM STYLE */
/* ========================================================================= */
.btn {
  padding: 0.875rem 2.5rem;
  border-radius: 0.75rem;
  font-weight: 700;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
  letter-spacing: 0.3px;
  position: relative;
  overflow: hidden;
}

.btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.btn:hover::before {
  width: 300px;
  height: 300px;
}

.btn:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.btn-primary {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  border-color: transparent;
  box-shadow: 0 6px 20px rgba(44, 90, 160, 0.3);
}

.btn-primary:hover {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 100%);
  box-shadow: 0 10px 30px rgba(44, 90, 160, 0.4);
}

.btn-outline-primary {
  color: #2c5aa0;
  border-color: #2c5aa0;
  border-width: 2px;
}

.btn-outline-primary:hover {
  background: #2c5aa0;
  color: white;
  border-color: #2c5aa0;
}

.btn-light {
  background: white;
  color: #2c5aa0;
  box-shadow: 0 6px 20px rgba(255, 255, 255, 0.3);
  font-weight: 700;
}

.btn-light:hover {
  background: #f8f9fa;
  color: #1e3f70;
  box-shadow: 0 10px 30px rgba(255, 255, 255, 0.5);
}

.btn-outline-light {
  color: white;
  border-color: white;
  border-width: 2px;
}

.btn-outline-light:hover {
  background: white;
  color: #2c5aa0;
  border-color: white;
}

/* ========================================================================= */
/* SCROLL BUTTON - ANIMATED */
/* ========================================================================= */
.scroll-top-btn {
  position: fixed;
  bottom: 35px;
  right: 35px;
  width: 55px;
  height: 55px;
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  color: white;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 8px 25px rgba(44, 90, 160, 0.4);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1000;
  font-size: 1.8rem;
}

.scroll-top-btn:hover {
  transform: translateY(-8px) scale(1.1);
  box-shadow: 0 15px 40px rgba(44, 90, 160, 0.6);
}

.scroll-top-btn::after {
  content: '';
  position: absolute;
  inset: -5px;
  border-radius: 50%;
  border: 2px solid #4a90e2;
  opacity: 0;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 0;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.2);
  }
}

/* ========================================================================= */
/* FOOTER - MODERN */
/* ========================================================================= */
footer {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 100%);
}

footer a {
  transition: all 0.3s ease;
}

footer a:hover {
  color: white !important;
  transform: translateX(5px);
}

.social-links a {
  transition: all 0.3s ease;
  display: inline-block;
}

.social-links a:hover {
  transform: translateY(-5px) scale(1.2);
  color: #4a90e2 !important;
}

/* ========================================================================= */
/* GRADIENT SECTION */
/* ========================================================================= */
.bg-gradient {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 50%, #4a90e2 100%);
  position: relative;
  overflow: hidden;
}

.bg-gradient::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
      radial-gradient(circle at 30% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 70% 80%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);
}

/* ========================================================================= */
/* ANIMATIONS */
/* ========================================================================= */
.animate-on-scroll {
  opacity: 0;
  transform: translateY(40px);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.animate-on-scroll.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* ========================================================================= */
/* RESPONSIVE */
/* ========================================================================= */
@media (max-width: 768px) {
  .hero-content h1 {
    font-size: 2.2rem;
  }

  .stat-number {
    font-size: 1.8rem;
  }

  .timeline::before {
    left: 15px;
  }

  .timeline-item {
    padding-left: 60px;
  }

  .timeline-marker {
    left: 7px;
  }

  .btn {
    padding: 0.75rem 2rem;
  }
}

/* ========================================================================= */
/* UTILITY */
/* ========================================================================= */
.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.bg-light {
  background: #f8f9fa !important;
}
</style>